import { MyReportsColumn } from './MyReportsTableHead';

/** Width of the sticky right-hand actions column, shared by the head and the colgroup. */
export const MY_REPORTS_ACTIONS_COL_WIDTH = 90;

/**
 * Column definitions for the My Reports table.
 *
 * `name` is the only flex column, so it absorbs all the slack and every other
 * column keeps the pixel width it needs. That single-flex shape is what stops
 * the columns bunching up: under `table-layout: fixed` the colgroup governs
 * sizing, and `buildColLayout` turns this list into those widths.
 */
export const MY_REPORTS_COLUMNS: MyReportsColumn[] = [
  { key: 'name', label: 'Report Name', sortable: true, flex: 1, minWidth: 240 },
  { key: 'code', label: 'Report ID', width: 150 },
  { key: 'pageName', label: 'Page', sortable: true, width: 150 },
  { key: 'reportOwner', label: 'Report Owner', sortable: true, width: 170 },
  { key: 'createdAt', label: 'Created', sortable: true, width: 170 },
  { key: 'sharedWith', label: 'Shared With', width: 200 },
  { key: 'scheduledDetails', label: 'Scheduled', width: 230 },
];

// Client/customer users get a curated My Reports view: the audit/sharing
// columns below are internal-only and removed for them. Kept in sync with the
// Shared/Scheduled name-row pills (also hidden for clients) in MyReportsTableRow,
// and with the quick-find haystack in myReportsListHelpers.
export const CLIENT_HIDDEN_COLUMN_KEYS: string[] = ['createdAt', 'sharedWith', 'scheduledDetails'];

/**
 * The columns to render for this user. Widths are always derived from the
 * result, so the client variant re-splits the slack instead of leaving a gap
 * where the hidden columns used to be.
 */
export const getVisibleMyReportsColumns = (isClient: boolean): MyReportsColumn[] =>
  isClient
    ? MY_REPORTS_COLUMNS.filter((col) => !CLIENT_HIDDEN_COLUMN_KEYS.includes(col.key))
    : MY_REPORTS_COLUMNS;
